/**
 * De lijniconen van werkplek v6, letterlijk uit de goedgekeurde mock
 * (`docs/werkplek/v6/mock.html`). Eén component, naam als prop.
 */
import type { SVGProps } from "react";

const PADEN = {
  zoek: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </>
  ),
  chat: <path d="M4 5h16v11H9l-5 4z" />,
  whatsapp: (
    <>
      <path d="M4 20l1.3-3.8A8 8 0 1 1 8 19.2z" />
      <path d="M9.5 9.5c0 3 2 5 5 5l1-1.5-2-1-1 1a4 4 0 0 1-1.5-1.5l1-1-1-2z" />
    </>
  ),
  telefoon: (
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
  ),
  vandaag: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18M8 2v4M16 2v4" />
    </>
  ),
  klanten: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M3 20a6 6 0 0 1 12 0M16 4a3.5 3.5 0 0 1 0 7M21 20a6 6 0 0 0-5-5.9" />
    </>
  ),
  retour: (
    <>
      <path d="M9 14l-4-4 4-4" />
      <path d="M5 10h10a5 5 0 0 1 0 10h-4" />
    </>
  ),
  ster: (
    <path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z" />
  ),
  signaal: <path d="M3 17l5-6 4 4 5-8 4 5" />,
  kennis: (
    <>
      <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" />
      <path d="M4 19a2 2 0 0 1 2-2h13" />
    </>
  ),
  hart: <path d="M3 12h4l2-5 3 10 2-6 1.5 3H21" />,
  beheer: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  sluit: <path d="M5 12l4 4L19 6" />,
  spam: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M5.5 5.5l13 13" />
    </>
  ),
  prul: (
    <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6" />
  ),
  notitie: (
    <>
      <path d="M5 4h14v12l-4 4H5z" />
      <path d="M15 20v-4h4M8 9h8M8 13h5" />
    </>
  ),
  meer: (
    <>
      <circle cx="6" cy="12" r="1.3" />
      <circle cx="12" cy="12" r="1.3" />
      <circle cx="18" cy="12" r="1.3" />
    </>
  ),
  klip: (
    <path d="M20 12l-8.5 8.5a5 5 0 0 1-7-7L13 5a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 7" />
  ),
  stuur: <path d="M3 11l18-8-8 18-2-8z" />,
  pijl: <path d="M6 9l6 6 6-6" />,
  terug: <path d="M15 5l-7 7 7 7" />,
  ok: <path d="M5 12l4 4L19 6" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  klant: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </>
  ),
  copiloot: (
    <>
      <path d="M12 3l1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8z" />
      <path d="M5 17l.8 1.7L7.5 19.5l-1.7.8L5 22l-.8-1.7-1.7-.8 1.7-.8z" />
    </>
  ),
  bel: (
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
  ),
  play: <path d="M8 5l11 7-11 7z" />,
  plus: <path d="M12 5v14M5 12h14" />,
  doc: (
    <>
      <path d="M6 3h8l4 4v14H6z" />
      <path d="M14 3v4h4M9 12h6M9 16h6" />
    </>
  ),
  antwoord: (
    <>
      <path d="M9 6L3 11l6 5" />
      <path d="M3 11h11a7 7 0 0 1 7 7v1" />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7L11.5 6.8" />
      <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.5-1.5" />
    </>
  ),
  beeld: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="8.5" cy="10" r="1.5" />
      <path d="M21 16l-5-5-8 8" />
    </>
  ),
  lijstje: <path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" />,
  taal: (
    <>
      <path d="M4 5h9M8.5 3v2M11 5c-1 4-3.5 7-7 9M6 8c1.5 3 4 5.5 7 7" />
      <path d="M13 20l4-9 4 9M14.5 17h5" />
    </>
  ),
  uit: <path d="M14 4h6v6M20 4l-8 8M10 5H5v14h14v-5" />,
  voorraad: (
    <>
      <path d="M3 8l9-5 9 5v8l-9 5-9-5z" />
      <path d="M3 8l9 5 9-5M12 13v8" />
    </>
  ),
  // Sessie 105 (motor 6.1): standen altijd met symbool naast het woord.
  klok: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  min: <path d="M6 12h12" />,
  uitroep: (
    <>
      <path d="M12 3.5L21.5 20h-19z" />
      <path d="M12 10v4.5M12 17.5h.01" />
    </>
  ),
  schaduw: (
    <>
      <circle cx="12" cy="12" r="8.5" strokeDasharray="3 2.6" />
      <path d="M12 8v8" />
    </>
  ),
  rond: <circle cx="12" cy="12" r="8" />,
  omhoog: <path d="M6 15l6-6 6 6" />,
  motor: (
    <>
      <path d="M4.5 17a8 8 0 1 1 15 0" />
      <path d="M12 13l4-4M12 13h.01" />
    </>
  ),
} as const;

export type IcoonNaam = keyof typeof PADEN;

export function Icoon({
  naam,
  klein = false,
  className,
  ...rest
}: { naam: IcoonNaam; klein?: boolean } & SVGProps<SVGSVGElement>) {
  const maat = klein ? 15 : 18;
  return (
    <svg
      viewBox="0 0 24 24"
      width={maat}
      height={maat}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={["v6-icoon", className].filter(Boolean).join(" ")}
      {...rest}
    >
      {PADEN[naam]}
    </svg>
  );
}
